import React, { useState } from 'react';
import { Trash2, ArrowUp, ArrowDown, Upload, Loader2, Image as ImageIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useHeroImages } from '../../hooks/useHeroImages';
import { compressHeroImage } from '../../utils/imageUtils';
export function HeroImagesSection() {
  const {
    images,
    addImage,
    deleteImage,
    moveImage,
    canAdd
  } = useHeroImages();
  const [isProcessing, setIsProcessing] = useState(false);
  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setIsProcessing(true);
      try {
        const file = e.target.files[0];
        // Usar compressHeroImage para máxima optimización
        const compressed = await compressHeroImage(file);
        await addImage(compressed);
      } catch (error) {
        console.error('Error processing image:', error);
        alert('Error al procesar la imagen.');
      } finally {
        setIsProcessing(false);
        e.target.value = '';
      }
    }
  };
  const handleDelete = (id: string) => {
    if (window.confirm('¿Estás seguro de eliminar esta imagen?')) {
      deleteImage(id);
    }
  };
  return <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6" data-id="element-223">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4" data-id="element-224">
        <div data-id="element-225">
          <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2" data-id="element-226">
            <ImageIcon className="h-5 w-5 text-blue-600" data-id="element-227" />
            Imágenes del Hero
          </h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-228">
            Máximo 4 imágenes. Se optimizan automáticamente para carga rápida.
          </p>
        </div>
        <div className="text-sm font-medium bg-blue-50 text-blue-700 px-3 py-1 rounded-full border border-blue-100" data-id="element-229">
          {images.length}/4 imágenes
        </div>
      </div>

      {/* Images Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-230">
        {images.map((image, index) => <div key={image.id} className="group relative aspect-video rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-all bg-gray-100" data-id="element-231">
            <img src={image.url} alt={`Hero ${index + 1}`} className="w-full h-full object-cover" data-id="element-232" />

            {/* Overlay controls */}
            <div className="absolute inset-0 flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity bg-black/40 backdrop-blur-[1px]" data-id="element-233">
              <button onClick={() => moveImage(image.id!, 'up')} disabled={index === 0} className="p-1.5 bg-white text-gray-700 hover:text-blue-600 rounded shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" title="Mover arriba" data-id="element-234">
                <ArrowUp className="h-3 w-3" data-id="element-235" />
              </button>
              <button onClick={() => moveImage(image.id!, 'down')} disabled={index === images.length - 1} className="p-1.5 bg-white text-gray-700 hover:text-blue-600 rounded shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" title="Mover abajo" data-id="element-236">
                <ArrowDown className="h-3 w-3" data-id="element-237" />
              </button>
              <button onClick={() => handleDelete(image.id!)} className="p-1.5 bg-white text-red-500 hover:text-red-700 rounded shadow-sm" title="Eliminar" data-id="element-238">
                <Trash2 className="h-3 w-3" data-id="element-239" />
              </button>
            </div>

            {/* Order badge */}
            <div className="absolute top-2 left-2 bg-black/60 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-240">
              #{index + 1}
            </div>
          </div>)}
      </div>

      {/* Upload Button */}
      {canAdd && <div className="bg-blue-50 border-2 border-dashed border-blue-200 rounded-lg p-6" data-id="element-241">
          <div className="text-center" data-id="element-242">
            <p className="text-sm font-semibold text-blue-900 mb-3" data-id="element-243">
              ⚡ Las imágenes se optimizan automáticamente para carga rápida
            </p>
            <label className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border-2 border-blue-300 cursor-pointer hover:border-blue-500 hover:bg-blue-100 transition-colors bg-white ${isProcessing ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-244">
              {isProcessing ? <Loader2 className="h-5 w-5 text-blue-500 animate-spin" data-id="element-245" /> : <Upload className="h-5 w-5 text-blue-500" data-id="element-246" />}
              <span className="text-sm font-medium text-blue-700" data-id="element-247">
                {isProcessing ? 'Optimizando imagen...' : 'Subir imagen del hero'}
              </span>
              <input type="file" accept="image/*" className="hidden" onChange={handleImageUpload} disabled={isProcessing} data-id="element-248" />
            </label>
            <p className="text-xs text-gray-500 mt-2" data-id="element-249">
              Recomendado: 1920x1080px, formato JPG
            </p>
          </div>
        </div>}

      {!canAdd && <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-center" data-id="element-250">
          <p className="text-sm text-yellow-800" data-id="element-251">
            Has alcanzado el máximo de 4 imágenes. Elimina una para agregar
            otra.
          </p>
        </div>}
    </div>;
}